import * as wasm from '../wasm.js';
export class DpnsFacade {
    constructor(sdk) {
        this.sdk = sdk;
    }
    async convertToHomographSafe(input) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.dpnsConvertToHomographSafe(input);
    }
    async isValidUsername(label) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.dpnsIsValidUsername(label);
    }
    async isContestedUsername(label) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.dpnsIsContestedUsername(label);
    }
    async isNameAvailable(label) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.dpnsIsNameAvailable(label);
    }
    async resolveName(name) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.dpnsResolveName(name);
    }
    async registerName(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.dpnsRegisterName(options);
    }
    async usernames(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDpnsUsernames(query);
    }
    async username(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDpnsUsername(identityId);
    }
    async usernamesWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDpnsUsernamesWithProofInfo(query);
    }
    async usernameWithProof(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDpnsUsernameWithProofInfo(identityId);
    }
    async getUsernameByName(username) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDpnsUsernameByName(username);
    }
    async getUsernameByNameWithProof(username) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDpnsUsernameByNameWithProofInfo(username);
    }
}
